import React from "react";
import { Tree, Button, Spin } from "antd";
import WeaInputSearch from "../../wea-input-search";
// import WeaNewScroll from "../../wea-new-scroll";
import trim from "lodash/trim";
import isEqual from "lodash/isEqual";
import debounce from "lodash/debounce";
import WeaLocaleProvider from "../../wea-locale-provider";
import WeaAvatar from "../../wea-avatar";
import { stopPropagation } from "../util";
import { SortableList, SortableListItem } from "./SortableList";
import SelectedDialog from "./SelectedDialog";

const TreeNode = Tree.TreeNode;
const getLabel = WeaLocaleProvider.getLabel;
let timeout = null;

const text = (item, field) => {
  let text = "";
  if (item[field] !== undefined) {
    text = item[field];
  }
  if (item[field + "span"] !== undefined) {
    text = item[field + "span"];
  }
  return text;
};

const displaySpan = (fields, item) =>
  (fields || []).map(field => (
    <span
      style={{ marginRight: 5 }}
      dangerouslySetInnerHTML={{ __html: text(item, field) }}
    />
  ));

export default class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      key: "",
      loading: false,
      visible: false,
      showData: []
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.data !== nextProps.data ||
      this.state.key !== nextState.key ||
      this.props.checkedKeys !== nextProps.checkedKeys
    );
  }
  componentDidMount() {
    console.log("selected list did mount");
    this.setShowData();
  }
  componentWillReceiveProps(nextProps) {
    const data = nextProps.data;
    if (!isEqual(this.props.data, data)) {
      const showData = this.getShowData(nextProps, this.state.key);
      this.setState({ showData }, () => {
        this.forceUpdate();
      });
    }
  }
  count(item) {
    if (item.type === "all") return item.count;
    return (item.users || []).length;
  }
  isCrm = () => {
    const { type } = this.props;
    return type == 1 || type == 17;
  };
  onSelectedGroupExpand(e, item) {
    stopPropagation(e);
    const { onSelectedGroupExpand } = this.props;
    if (typeof onSelectedGroupExpand === "function")
      onSelectedGroupExpand(item);
  }
  hideExtra = showData => {
    const { data, maxDataLength, forceShowAll } = this.props;
    showData = showData || data;
    return !forceShowAll && showData.length > maxDataLength;
  };
  setShowData = (props, key) => {
    props = props || this.props;
    key = key || this.state.key;
    let showData = this.getShowData(props, key);
    let loading = false;
    if (props.needLoading) {
      loading = true;
      setTimeout(() => {
        this.setState(
          { showData: this.getShowData(props, key), loading: false },
          () => {
            this.forceUpdate();
          }
        );
      }, 500);
      showData = showData.slice(0, props.maxShowDataLength);
    }
    this.setState({ showData, loading }, () => {
      this.forceUpdate();
    });
  };
  getShowData = (props, key) => {
    props = props || this.props;
    key = key || this.state.key || "";
    const { data, inputId, inputName, inputTop } = props;
    let showData = data || [];
    if (this.isCrm()) {
      if (trim(key)) {
        showData = showData.filter(item => {
          let bool = false;
          bool = item.lastname.indexOf(trim(key)) > -1;
          if (!bool && item.pingyinname) {
            bool = item.pingyinname.indexOf(trim(key)) > -1;
          }
          return bool;
        });
      }
    } else if (inputId) {
      if (trim(key)) {
        showData = showData.filter(item => {
          if (inputTop.length > 0) {
            return item[inputTop[0]].indexOf(trim(key)) > -1;
          }
          return item[inputName] && item[inputName].indexOf(trim(key)) > -1;
        });
      }
    }
    return showData;
  };
  getItemRender = data => {
    const {
      inputId,
      inputName,
      inputTop,
      inputBottom,
      type,
      hideNum,
      isShowGroup
    } = this.props;
    let item = { ...(data || {}) };
    let title = null;
    if (this.isCrm()) {
      const crmNames = [];
      if (item.departmentname) crmNames.push(item.departmentname);
      if (item.supsubcompanyname) crmNames.push(item.supsubcompanyname);
      if (item.subcompanyname) crmNames.push(item.subcompanyname);
      item.crmNames = crmNames.join("／");
      if (item.type == "resource") {
        let requestParams;
        try {
          if (item.requestParams) {
            requestParams = JSON.parse(item.requestParams);
          }
        } catch (e) {
          requestParams = undefined;
        }
        title = (
          <div className="tree-title sortable-list-item resource">
            <WeaAvatar
              className="wea-tree-hr-portrait"
              userId={item.id}
              requestParams={requestParams}
            />
            <div className="resource-content breakall">
              <div>
                {inputTop || inputBottom
                  ? displaySpan(inputTop, item)
                  : [
                      <span className="lastname" title={item.lastname}>
                        {item.lastname}
                      </span>,
                      <span
                        className="jobtitlename gray"
                        title={item.jobtitlename}
                      >
                        {item.jobtitlename}
                      </span>
                    ]}
              </div>
              <div>
                {inputTop || inputBottom ? (
                  displaySpan(inputBottom, item)
                ) : (
                  <div className="overflow gray" title={item.crmNames}>
                    {item.crmNames}
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      } else {
        title = (
          <div className="tree-title sortable-list-item">
            <span className="tree-title-icon">
              {item.type === "dept" ? (
                <i className="icon-mail-folder" />
              ) : (
                <i className="icon-process-scene" />
              )}
            </span>
            <span
              className={`tree-title-name ${
                isShowGroup ? "has-expand-icon" : ""
              }`}
              title={item.lastname}
            >
              {item.lastname}
              {!hideNum && `(${this.count(item)})`}
            </span>
            {isShowGroup && (
              <span
                title={getLabel(520392, "拆分显示")}
                className="tree-title-expand"
                onClick={e => this.onSelectedGroupExpand(e, item)}
                onDoubleClick={stopPropagation}
              >
                <i className="icon-coms02-split" />
              </span>
            )}
          </div>
        );
      }
    } else if (inputId) {
      const top = displaySpan(inputTop, item);
      const bottom = displaySpan(inputBottom, item);
      title = (
        <div className="item-wrap">
          <div className="item-top">{top}</div>
          <div className="item-bottom">{bottom}</div>
        </div>
      );
    }
    return title;
  };
  generateTreeNodes(showData = []) {
    const { inputId, type } = this.props;
    const treeNodes = [];
    if (this.isCrm()) {
      this.nodeIds = [];
      this.nodeObj = {};
      showData.map(item => {
        const title = this.getItemRender(item);
        treeNodes.push(
          <TreeNode
            title={title}
            name={item.lastname}
            jobtitlename={item.jobtitlename}
            key={item.nodeid}
            isLeaf={true}
            id={item.id}
            type={item.type}
          />
        );
        this.nodeIds.push(item.nodeid);
        this.nodeObj[item.nodeid] = item;
      });
    } else if (inputId) {
      this.nodeIds = [];
      this.nodeObj = {};
      showData.map(item => {
        const title = this.getItemRender(item);
        treeNodes.push(
          <TreeNode title={title} key={item[inputId]} isLeaf={true} />
        );
        this.nodeIds.push(item[inputId]);
        this.nodeObj[item[inputId]] = item;
      });
    }
    return treeNodes;
  }
  onSearchChange = v => {
    this.setState({ key: v });
    this.setShowData(null, v);
  };
  onVisibleChange = visible => {
    const { onVisibleChange } = this.props;
    if (typeof onVisibleChange === "function") onVisibleChange(visible);
  };
  reset = () => {
    this.setState({ key: "" });
  };
  checkHandler = (v, p) => {
    let _this = this;
    // 取消上次延时未执行的方法
    clearTimeout(timeout);
    //执行延时
    timeout = setTimeout(function() {
      _this.props.checkedCb && _this.props.checkedCb(v);
    }, 200);
  };
  onDoubleClick = key => {
    clearTimeout(timeout);
    this.props.onDoubleClick && this.props.onDoubleClick(key);
  };
  onDragStart = obj => {
    clearTimeout(timeout);
    this.props.checkedCb && this.props.checkedCb([]);
  };
  onDrop(obj) {
    const dragNodes = obj.dragNodesKeys;
    const targetNode = obj.node.props.eventKey;
    const result = [];
    this.nodeIds
      .filter(item => dragNodes.indexOf(item) === -1)
      .forEach(id => {
        if (id === targetNode) {
          dragNodes.forEach(drag => result.push(this.nodeObj[drag]));
        }
        result.push(this.nodeObj[id]);
      });
    this.props.onDrag && this.props.onDrag(result);
  }
  render() {
    const {
      visible,
      checkedKeys,
      height,
      data,
      inputId,
      forceShowAll,
      getDataKey,
      maxShowDataLength
    } = this.props;
    let { showData, loading } = this.state;
    // let showData = this.getShowData();
    const hideExtra = this.hideExtra(showData);
    const hideLength = showData.length;
    if (hideExtra) {
      showData = showData.slice(0, maxShowDataLength);
    } else {
      console.log(showData.length);
    }
    // const treeNodes = this.generateTreeNodes(showData);
    return (
      <div className="wea-transfer-right">
        <WeaInputSearch
          onSearchChange={debounce(this.onSearchChange, 200).bind(this)}
          placeholder={getLabel(83788, "请输入关键字搜索")}
          value={this.state.key}
        />
        {/* <WeaNewScroll height={(height || 400) - (hideExtra ? 35 : 0)}>
          <Tree
            className="transfer-tree"
            draggable
            onDragStart={this.onDragStart.bind(this)}
            onDrop={this.onDrop.bind(this)}
            onSelect={this.checkHandler.bind(this)}
            onDoubleClick={this.onDoubleClick.bind(this)}
            selectedKeys={checkedKeys}
            multiple={true}
            async={true}
            selectable={true}
          >
            {treeNodes}
          </Tree>
        </WeaNewScroll> */}
        <Spin spinning={loading}>
          <div
            style={{
              height: (height || 400) - (hideExtra ? 35 : 0),
              overflowY: "auto"
            }}
          >
            <SortableList
              onChange={order => {
                let result = order
                  .map(id =>
                    data.find(
                      d =>
                        (getDataKey
                          ? getDataKey(d)
                          : d[this.isCrm() ? "nodeid" : inputId]) == id
                    )
                  )
                  .filter(d => !!d);
                if (hideExtra) {
                  result = result.concat(data.slice(maxShowDataLength));
                }
                this.props.onDrag && this.props.onDrag(result);
              }}
            >
              {showData.map(item => (
                <SortableListItem
                  key={
                    getDataKey
                      ? getDataKey(item)
                      : item[this.isCrm() ? "nodeid" : inputId]
                  }
                  data={item}
                  draggable
                  selectable
                  multiple
                  selectedKeys={checkedKeys}
                  getDataKey={
                    getDataKey || (d => d[this.isCrm() ? "nodeid" : inputId])
                  }
                  getItemRender={this.getItemRender}
                  onSelect={this.checkHandler}
                  onDoubleClick={this.onDoubleClick}
                  onDragStart={this.onDragStart}
                />
              ))}
            </SortableList>
          </div>
        </Spin>
        {hideExtra && [
          <div
            className="show-all-selected-data"
            onClick={() => this.onVisibleChange(true)}
          >
            <span>
              {getLabel(-1, "查看全部$s条数据").replace("$s", hideLength)}
            </span>
          </div>
        ]}
        {!forceShowAll && (
          <SelectedDialog
            {...this.props}
            onVisibleChange={this.onVisibleChange}
            dialogProps={{ visible }}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/components/WeaSelectedRight.js